import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "f182257c-ec56-4059-9ceb-83e9dc59fabe",
    content: "The SPL in the receiving room is larger behind the second facade.",
    options: {},
  },
  {
    id: "f7a4de7c-c052-460e-ba2b-42456e825b06",
    content: "The SPL in the receiving room is lower behind the first facade.",
    options: {},
  },
  {
    id: "bb5d561b-e8f2-4ed3-9be5-3ca9615ddf41",
    content: "The SPL in the receiving room is the same in both cases.",
    options: {},
  },
  { id: "76985826-30e4-4095-8487-1844b21aa7ce", content: "It cannot be determined.", options: {} },
];

export const task: Task = {
  id: "e180d641-88ba-4a10-90ff-6b90c3106a6d",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: false,
    columns: 1,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["bb5d561b-e8f2-4ed3-9be5-3ca9615ddf41"],
};
